export default __webpack_public_path__ + "static/media/KBISHOP.e5b37a03.jpg";